import { render, staticRenderFns } from "./WhiteSpotsPopup.vue?vue&type=template&id=795af7e4"
import script from "./WhiteSpotsPopup.vue?vue&type=script&lang=js"
export * from "./WhiteSpotsPopup.vue?vue&type=script&lang=js"
import style0 from "./WhiteSpotsPopup.vue?vue&type=style&index=0&id=795af7e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports